export const DEFAULT_REPORTS = [
    {
        "_id": "68ffa9d9906349adc2ad628d",
        "order": 8,
        "type": "custom-groups-comparison",
        "title": "Compare Creatives Types",
        "description": "Uncover where your ad spend is driving results—and where its falling short",
        "metricKeys": [
            "spend",
            "roas"
        ],
        "filters": [],
        "customGroups": [
            {
                "name": "Images",
                "groupFilters": [
                    [
                        {
                            "optionId": "ad_type",
                            "value": [
                                "image"
                            ],
                            "operatorValue": "is"
                        }
                    ]
                ],
                "id": "0.5747008092342629"
            },
            {
                "name": "Videos",
                "groupFilters": [
                    [
                        {
                            "optionId": "ad_type",
                            "value": [
                                "video"
                            ],
                            "operatorValue": "is"
                        }
                    ]
                ],
                "id": "0.11007227429752242"
            }
        ],
        "chartType": "comparison",
        "groupBy": {
            "key": "ad_creative",
            "label": "Creative"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-17T10:30:36.784Z",
        "createdAt": "2025-10-27T17:20:25.555Z",
        "columns": [
            {
                "key": "spend",
                "name": "Spend",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total amount of money spent on the asset.",
                "formula": "Sum of all expenses related to the asset.",
                "bestValue": "high",
                "isNatural": true,
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "purchase_value",
                "name": "Purchase value",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total value from purchases.",
                "formula": "Sum of Purchase Values",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "roas",
                "name": "ROAS",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "displaySum": false,
                "displayAverage": true,
                "bestValue": "high",
                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                "formula": "Revenue / Spend",
                "dependsOn": [
                    "spend",
                    "purchase_value"
                ]
            },
            {
                "key": "purchases",
                "name": "Purchases",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": false,
                "percentages": false,
                "description": "Total number of purchase events",
                "formula": "Sum of Purchase Events",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "needVerify": true
            },
            {
                "key": "cpa",
                "name": "CPA",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": true,
                "percentages": false,
                "description": "Cost per acquisition - the cost to acquire a customer or conversion.",
                "formula": "SPEND / PURCHASES",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "purchases"
                ]
            },
            {
                "key": "aov",
                "name": "AOV",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": true,
                "percentages": false,
                "description": "Average order value - the average amount spent per order.",
                "formula": "Total Revenue / Total Orders",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "purchase_value",
                    "purchases"
                ]
            },
            {
                "key": "website_purchase_count",
                "name": "Website purchase count",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": false,
                "percentages": false,
                "description": "Total number of purchases made through the website.",
                "formula": "Sum of Website Purchases",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "impressions",
                "name": "Impressions",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "description": "Total number of times the ad was displayed.",
                "formula": "Count of ad views",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            }
        ],
        "multiSuperSegments": [],
        "superSegment": null,
        "icon": {
            "type": "icon",
            "value": "ph:stack",
            "color": "text-indigo-500"
        },
        "sort_order": 2,
        "folderId": null,
        "segmentConfigs": {
            "scaled": {
                "name": "Scaled",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:chart-line-up",
                    "color": "text-gray-500",
                    "bg": "bg-gray-500"
                }
            },
            "winners": {
                "name": "Winners",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ],
                    [
                        {
                            "optionId": "metric",
                            "value": "1",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "roas",
                                "name": "ROAS",
                                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                                "fromColor": "#A855F7",
                                "toColor": "#EC4899",
                                "currency": false,
                                "percentages": false,
                                "displaySum": false,
                                "displayAverage": true,
                                "bestValue": "high",
                                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                                "formula": "Revenue / Spend",
                                "dependsOn": [
                                    "spend",
                                    "purchase_value"
                                ]
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:trophy",
                    "color": "text-secondary",
                    "bg": "bg-secondary"
                }
            }
        },
        "metricsDisplayMode": "cards"
    },
    // {
    //     "_id": "68ffa9d9906349adc2ad628e",
    //     "order": 5,
    //     "title": "Copy Winner",
    //     "type": "top-performing",
    //     "description": "Discover which ads are generating profit and which are just draining your budget.",
    //     "metricKeys": [
    //         "see_more_rate",
    //         "clicks_all",
    //         "impressions"
    //     ],
    //     "chartType": "duel",
    //     "filters": [],
    //     "groupBy": {
    //         "key": "ad_copy",
    //         "label": "Copy"
    //     },
    //     "account": "674488689a710e2685c80963",
    //     "space": "68ffa9d0906349adc2ad628c",
    //     "updatedAt": "2026-06-15T18:07:09.117Z",
    //     "createdAt": "2025-10-27T17:20:25.558Z",
    //     "icon": {
    //         "type": "icon",
    //         "value": "ph:text-aa",
    //         "color": "text-indigo-500"
    //     },
    //     "sort_order": 9,
    //     "folderId": null,
    //     "columns": [
    //         {
    //             "key": "hook_rate",
    //             "name": "Hook Rate",
    //             "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
    //             "fromColor": "#FACC15",
    //             "toColor": "#F97316",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Percentage watching at least 3 seconds",
    //             "formula": "Hook rate (%) = (3-second video plays ÷ impressions) × 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "impressions",
    //                 "3s_video_plays"
    //             ]
    //         },
    //         {
    //             "key": "3s_video_plays",
    //             "name": "3s video plays",
    //             "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
    //             "fromColor": "#FACC15",
    //             "toColor": "#F97316",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "The number of times your video was played for at least 3 seconds.",
    //             "formula": "Count of video plays that lasted 3 seconds or longer",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "hook_to_25",
    //             "name": "Hook to 25%",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The percentage of viewers who kept watching past the hook and reached 25% of the video length.",
    //             "formula": "video_p25_watched / video_3s_plays",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p25_watched",
    //                 "3s_video_plays"
    //             ]
    //         },
    //         {
    //             "key": "video_50_to_25",
    //             "name": "Video Plays 50% / 25%",
    //             "color": "bg-gradient-to-r from-green-400 to-blue-500",
    //             "fromColor": "#4ADE80",
    //             "toColor": "#3B82F6",
    //             "percentages": true,
    //             "description": "The percentage of viewers who watched from 25% to at least halfway (50%) of the video.",
    //             "formula": "video_p50_watched / video_p25_watched",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p50_watched",
    //                 "video_p25_watched"
    //             ]
    //         },
    //         {
    //             "key": "video_75_to_50",
    //             "name": "Video Plays 75% / 50%",
    //             "color": "bg-gradient-to-r from-red-500 to-pink-500",
    //             "fromColor": "#EF4444",
    //             "toColor": "#EC4899",
    //             "percentages": true,
    //             "description": "The percentage of viewers who continued watching from halfway to 75% of the video.",
    //             "formula": "video_p75_watched / video_p50_watched",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p75_watched",
    //                 "video_p50_watched"
    //             ]
    //         },
    //         {
    //             "key": "video_100_to_75",
    //             "name": "Video Plays 100% / 75%",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "percentages": true,
    //             "description": "The percentage of viewers who continued watching from 75% to full length of the video.",
    //             "formula": "video_p100_watched / video_p75_watched",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p100_watched",
    //                 "video_p75_watched"
    //             ]
    //         },
    //         {
    //             "key": "video_avg_time_watched",
    //             "name": "Video avg. play time",
    //             "color": "bg-gradient-to-r from-red-500 to-pink-500",
    //             "fromColor": "#EF4444",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": false,
    //             "time": "s",
    //             "description": "Average play time of video content.",
    //             "formula": "Total Play Time / Video Views",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "thruplay",
    //             "name": "Thruplay",
    //             "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
    //             "fromColor": "#EC4899",
    //             "toColor": "#EAB308",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "Total number of times a video was played to completion.",
    //             "formula": "Sum of completed plays",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "thumbstop",
    //             "name": "Thumbstop",
    //             "color": "bg-gradient-to-r from-green-400 to-blue-500",
    //             "fromColor": "#4ADE80",
    //             "toColor": "#3B82F6",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The number of times users paused their scroll to watch your video ad for at least 3 seconds.",
    //             "formula": "(Count of video views lasting 3 seconds or more / Impressions) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "3s_video_plays",
    //                 "impressions"
    //             ]
    //         },
    //         {
    //             "key": "video_plays",
    //             "name": "Video plays",
    //             "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
    //             "fromColor": "#EC4899",
    //             "toColor": "#EAB308",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "The total number of times your video ad started playing.",
    //             "formula": "Count of all video play events",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "video_p100_watched",
    //             "name": "100% video plays",
    //             "color": "bg-gradient-to-r from-blue-500 to-teal-400",
    //             "fromColor": "#3B82F6",
    //             "toColor": "#2DD4BF",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "The number of times your video was played to completion",
    //             "formula": "Count of video plays that reached 100% of total video duration",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "15s_per_3s_video_retention",
    //             "name": "15s/3s video retention",
    //             "color": "bg-gradient-to-r from-purple-500 to-pink-500",
    //             "fromColor": "#A855F7",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Retention rate of users after watching 3 seconds of a 15-second video.",
    //             "formula": "(15s Views - 'THRUPLAY' / 3s Views) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "thruplay",
    //                 "3s_video_plays"
    //             ],
    //             "extractors": {}
    //         },
    //         {
    //             "key": "video_p95_watched",
    //             "name": "95% video plays",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "The number of times your video was played to 95% of its length.",
    //             "formula": "Count of video plays that reached 95% of total video duration",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "video_p25_play_rate",
    //             "name": "25% video plays (rate)",
    //             "color": "bg-gradient-to-r from-blue-500 to-teal-400",
    //             "fromColor": "#3B82F6",
    //             "toColor": "#2DD4BF",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The percentage of video impressions that reached 25% of the video length.",
    //             "formula": "(Number of 25% video plays / Total video impressions) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p25_watched",
    //                 "impressions"
    //             ],
    //             "extractors": {}
    //         },
    //         {
    //             "key": "75percent_to_95percent_video_plays_drop_off_rate",
    //             "name": "75% to 95% video plays drop off rate",
    //             "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
    //             "fromColor": "#EC4899",
    //             "toColor": "#EAB308",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The percentage of viewers who stopped watching between 75% and 95% of the video length.",
    //             "formula": "((Number of 75% plays - Number of 95% plays) / Number of 75% plays) * 100",
    //             "bestValue": "low",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p75_watched",
    //                 "video_p95_watched"
    //             ],
    //             "extractors": {}
    //         },
    //         {
    //             "key": "cost_per_3s_plays",
    //             "name": "Cost per 3s plays",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "currency": true,
    //             "percentages": false,
    //             "description": "The average cost you pay for each 3-second video view.",
    //             "formula": "Spend / Number of 3-second video plays",
    //             "bestValue": "low",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "spend",
    //                 "3s_video_plays"
    //             ]
    //         },
    //         {
    //             "key": "100percent_per_3s_video_retention",
    //             "name": "100%/3s video retention",
    //             "color": "bg-gradient-to-r from-purple-500 to-pink-500",
    //             "fromColor": "#A855F7",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Retention rate after watching 3 seconds of a 100% video.",
    //             "formula": "(100% Views / 3s Views) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p100_watched",
    //                 "3s_video_plays"
    //             ],
    //             "extractors": {}
    //         },
    //         {
    //             "key": "thruplay_ctr",
    //             "name": "Thruplay CTR",
    //             "color": "bg-gradient-to-r from-red-500 to-pink-500",
    //             "fromColor": "#EF4444",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Out of all those who watched the first 15s of a video, the percentage that clicked on it and left Meta properties",
    //             "formula": "(Outbound Clicks / VIDEO Thruplays) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "thruplay",
    //                 "clicks_all"
    //             ],
    //             "extractors": {}
    //         },
    //         {
    //             "key": "clicks_all",
    //             "name": "Clicks (all)",
    //             "color": "bg-gradient-to-r from-red-500 to-pink-500",
    //             "fromColor": "#EF4444",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "Total number of clicks (all types).",
    //             "formula": "Sum of all clicks",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "see_more_rate",
    //             "name": "See more rate",
    //             "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
    //             "fromColor": "#EC4899",
    //             "toColor": "#EAB308",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Rate of users clicking to see more.",
    //             "formula": "((Clicks (All) - Link Clicks - Post Reactions - Post Comments - Post Shares) / Impressions) * 100",
    //             "bestValue": "high",
    //             "dependsOn": [
    //                 "clicks_all",
    //                 "link_clicks",
    //                 "reactions",
    //                 "comments",
    //                 "shares",
    //                 "impressions"
    //             ],
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "impressions",
    //             "name": "Impressions",
    //             "color": "bg-gradient-to-r from-purple-500 to-pink-500",
    //             "fromColor": "#A855F7",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "Total number of times the ad was displayed.",
    //             "formula": "Count of ad views",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true,
    //             "extractors": {}
    //         },
    //         {
    //             "key": "aov",
    //             "name": "AOV",
    //             "color": "bg-gradient-to-r from-teal-400 to-green-500",
    //             "fromColor": "#2DD4BF",
    //             "toColor": "#22C55E",
    //             "currency": true,
    //             "percentages": false,
    //             "description": "Average order value - the average amount spent per order.",
    //             "formula": "Total Revenue / Total Orders",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "purchase_value",
    //                 "purchases"
    //             ]
    //         }
    //     ],
    //     "customGroups": [],
    //     "metricsDisplayMode": "cards",
    //     "segmentConfigs": {}
    // },
    {
        "_id": "68ffa9d9906349adc2ad6292",
        "order": 4,
        "title": "Winning Videos",
        "type": "top-performing",
        "chartType": "comparison",
        "description": "Uncover where your ad spend is driving results—and where it's falling short.",
        "metricKeys": [
            "spend",
            "hook_rate",
            "hook_to_25",
            "video_plays",
            "video_avg_time_watched"
        ],
        "filters": [
            [
                {
                    "optionId": "ad_type",
                    "value": [
                        "video"
                    ],
                    "operatorValue": "is"
                }
            ],
            [
                {
                    "optionId": "metric",
                    "operatorValue": "greater",
                    "value": "100",
                    "label": "Metric",
                    "chosenMetric": {
                        "key": "spend",
                        "name": "Spend",
                        "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                        "fromColor": "#3B82F6",
                        "toColor": "#2DD4BF",
                        "currency": true,
                        "percentages": false,
                        "description": "Total amount of money spent on the asset.",
                        "formula": "Sum of all expenses related to the asset.",
                        "bestValue": "high",
                        "isNatural": true,
                        "displaySum": true,
                        "displayAverage": true,
                        "extractors": {}
                    }
                }
            ]
        ],
        "groupBy": {
            "key": "ad_creative",
            "label": "Creative"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-17T10:30:14.129Z",
        "createdAt": "2025-10-27T17:20:25.574Z",
        "columns": [
            {
                "key": "hook_rate",
                "name": "Hook Rate",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": false,
                "percentages": true,
                "description": "Percentage watching at least 3 seconds",
                "formula": "Hook rate (%) = (3-second video plays ÷ impressions) × 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "impressions",
                    "3s_video_plays"
                ]
            },
            {
                "key": "3s_video_plays",
                "name": "3s video plays",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": false,
                "percentages": false,
                "description": "The number of times your video was played for at least 3 seconds.",
                "formula": "Count of video plays that lasted 3 seconds or longer",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "hook_to_25",
                "name": "Hook to 25%",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": true,
                "description": "The percentage of viewers who kept watching past the hook and reached 25% of the video length.",
                "formula": "video_p25_watched / video_3s_plays",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p25_watched",
                    "3s_video_plays"
                ]
            },
            {
                "key": "video_50_to_25",
                "name": "Video Plays 50% / 25%",
                "color": "bg-gradient-to-r from-green-400 to-blue-500",
                "fromColor": "#4ADE80",
                "toColor": "#3B82F6",
                "percentages": true,
                "description": "The percentage of viewers who watched from 25% to at least halfway (50%) of the video.",
                "formula": "video_p50_watched / video_p25_watched",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p50_watched",
                    "video_p25_watched"
                ]
            },
            {
                "key": "video_75_to_50",
                "name": "Video Plays 75% / 50%",
                "color": "bg-gradient-to-r from-red-500 to-pink-500",
                "fromColor": "#EF4444",
                "toColor": "#EC4899",
                "percentages": true,
                "description": "The percentage of viewers who continued watching from halfway to 75% of the video.",
                "formula": "video_p75_watched / video_p50_watched",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p75_watched",
                    "video_p50_watched"
                ]
            },
            {
                "key": "video_100_to_75",
                "name": "Video Plays 100% / 75%",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "percentages": true,
                "description": "The percentage of viewers who continued watching from 75% to full length of the video.",
                "formula": "video_p100_watched / video_p75_watched",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p100_watched",
                    "video_p75_watched"
                ]
            },
            {
                "key": "video_avg_time_watched",
                "name": "Video avg. play time",
                "color": "bg-gradient-to-r from-red-500 to-pink-500",
                "fromColor": "#EF4444",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "time": "s",
                "description": "Average play time of video content.",
                "formula": "Total Play Time / Video Views",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true
            },
            {
                "key": "thruplay",
                "name": "Thruplay",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": false,
                "percentages": false,
                "description": "Total number of times a video was played to completion.",
                "formula": "Sum of completed plays",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "thumbstop",
                "name": "Thumbstop",
                "color": "bg-gradient-to-r from-green-400 to-blue-500",
                "fromColor": "#4ADE80",
                "toColor": "#3B82F6",
                "currency": false,
                "percentages": true,
                "description": "The number of times users paused their scroll to watch your video ad for at least 3 seconds.",
                "formula": "(Count of video views lasting 3 seconds or more / Impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "3s_video_plays",
                    "impressions"
                ]
            },
            {
                "key": "video_plays",
                "name": "Video plays",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": false,
                "percentages": false,
                "description": "The total number of times your video ad started playing.",
                "formula": "Count of all video play events",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "video_p100_watched",
                "name": "100% video plays",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": false,
                "percentages": false,
                "description": "The number of times your video was played to completion",
                "formula": "Count of video plays that reached 100% of total video duration",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "15s_per_3s_video_retention",
                "name": "15s/3s video retention",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": true,
                "description": "Retention rate of users after watching 3 seconds of a 15-second video.",
                "formula": "(15s Views - 'THRUPLAY' / 3s Views) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "thruplay",
                    "3s_video_plays"
                ],
                "extractors": {}
            },
            {
                "key": "video_p95_watched",
                "name": "95% video plays",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": false,
                "description": "The number of times your video was played to 95% of its length.",
                "formula": "Count of video plays that reached 95% of total video duration",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "video_p25_play_rate",
                "name": "25% video plays (rate)",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": false,
                "percentages": true,
                "description": "The percentage of video impressions that reached 25% of the video length.",
                "formula": "(Number of 25% video plays / Total video impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p25_watched",
                    "impressions"
                ],
                "extractors": {}
            },
            {
                "key": "75percent_to_95percent_video_plays_drop_off_rate",
                "name": "75% to 95% video plays drop off rate",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": false,
                "percentages": true,
                "description": "The percentage of viewers who stopped watching between 75% and 95% of the video length.",
                "formula": "((Number of 75% plays - Number of 95% plays) / Number of 75% plays) * 100",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p75_watched",
                    "video_p95_watched"
                ],
                "extractors": {}
            },
            {
                "key": "cost_per_3s_plays",
                "name": "Cost per 3s plays",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": true,
                "percentages": false,
                "description": "The average cost you pay for each 3-second video view.",
                "formula": "Spend / Number of 3-second video plays",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "3s_video_plays"
                ]
            },
            {
                "key": "100percent_per_3s_video_retention",
                "name": "100%/3s video retention",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": true,
                "description": "Retention rate after watching 3 seconds of a 100% video.",
                "formula": "(100% Views / 3s Views) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p100_watched",
                    "3s_video_plays"
                ],
                "extractors": {}
            },
            {
                "key": "thruplay_ctr",
                "name": "Thruplay CTR",
                "color": "bg-gradient-to-r from-red-500 to-pink-500",
                "fromColor": "#EF4444",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": true,
                "description": "Out of all those who watched the first 15s of a video, the percentage that clicked on it and left Meta properties",
                "formula": "(Outbound Clicks / VIDEO Thruplays) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "thruplay",
                    "clicks_all"
                ],
                "extractors": {}
            },
            {
                "key": "clicks_all",
                "name": "Clicks (all)",
                "color": "bg-gradient-to-r from-red-500 to-pink-500",
                "fromColor": "#EF4444",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "description": "Total number of clicks (all types).",
                "formula": "Sum of all clicks",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "spend",
                "name": "Spend",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total amount of money spent on the asset.",
                "formula": "Sum of all expenses related to the asset.",
                "bestValue": "high",
                "isNatural": true,
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            }
        ],
        "customGroups": [],
        "multiSuperSegments": [],
        "superSegment": null,
        "icon": {
            "type": "icon",
            "value": "ph:video-camera",
            "color": "text-secondary-500"
        },
        "folderId": null,
        "segmentConfigs": {
            "scaled": {
                "name": "Scaled",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:chart-line-up",
                    "color": "text-gray-500",
                    "bg": "bg-gray-500"
                }
            },
            "winners": {
                "name": "Winners",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ],
                    [
                        {
                            "optionId": "metric",
                            "value": "1",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "roas",
                                "name": "ROAS",
                                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                                "fromColor": "#A855F7",
                                "toColor": "#EC4899",
                                "currency": false,
                                "percentages": false,
                                "displaySum": false,
                                "displayAverage": true,
                                "bestValue": "high",
                                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                                "formula": "Revenue / Spend",
                                "dependsOn": [
                                    "spend",
                                    "purchase_value"
                                ]
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:trophy",
                    "color": "text-secondary",
                    "bg": "bg-secondary"
                }
            }
        },
        "metricsDisplayMode": "chips"
    },
    {
        "_id": "68ffa9d9906349adc2ad6293",
        "order": 7,
        "title": "Ad Wear-Out",
        "type": "top-performing",
        "chartType": "line",
        "description": "Uncover where your ad spend is driving results—and where its falling short",
        "metricKeys": [
            "ctr",
            "cpm"
        ],
        "filters": [],
        "groupBy": {
            "key": "ad_creative",
            "label": "Creative"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-15T18:07:09.109Z",
        "createdAt": "2025-10-27T17:20:25.582Z",
        "columns": [
            {
                "key": "spend",
                "name": "Spend",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total amount of money spent on the asset.",
                "formula": "Sum of all expenses related to the asset.",
                "bestValue": "high",
                "isNatural": true,
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "roas",
                "name": "ROAS",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "displaySum": false,
                "displayAverage": true,
                "bestValue": "high",
                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                "formula": "Revenue / Spend",
                "dependsOn": [
                    "spend",
                    "purchase_value"
                ]
            },
            {
                "key": "impressions",
                "name": "Impressions",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "description": "Total number of times the ad was displayed.",
                "formula": "Count of ad views",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "hook_rate",
                "name": "Hook Rate",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": false,
                "percentages": true,
                "description": "Percentage watching at least 3 seconds",
                "formula": "Hook rate (%) = (3-second video plays ÷ impressions) × 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "impressions",
                    "3s_video_plays"
                ]
            },
            {
                "key": "hook_to_25",
                "name": "Hook to 25%",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": true,
                "description": "The percentage of viewers who kept watching past the hook and reached 25% of the video length.",
                "formula": "video_p25_watched / video_3s_plays",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "video_p25_watched",
                    "3s_video_plays"
                ]
            },
            {
                "key": "cpm",
                "name": "CPM",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": true,
                "percentages": false,
                "description": "Cost per 1000 impressions",
                "formula": "(Total Spend / Total Impressions) * 1000",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "impressions"
                ]
            },
            {
                "key": "ctr",
                "name": "CTR",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": true,
                "description": "Click-through rate for all clicks.",
                "formula": "(Total Clicks / Total Impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "clicks_all",
                    "impressions"
                ]
            },
            {
                "key": "frequency",
                "name": "Frequency",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": false,
                "percentages": false,
                "description": "How many times, on average, each person saw the ad during the selected date range.",
                "formula": "",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true
            },
            {
                "key": "ctr_link_click",
                "name": "CTR (link click)",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": false,
                "percentages": true,
                "description": "Click-through rate for link clicks.",
                "formula": "(Link Clicks / Impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "link_clicks",
                    "impressions"
                ]
            }
        ],
        "customGroups": [],
        "icon": {
            "type": "icon",
            "value": "ph:trend-down",
            "color": "text-red-500"
        },
        "sort_order": 3,
        "folderId": null
    },
    // {
    //     "_id": "68ffa9d9906349adc2ad6294",
    //     "order": 6,
    //     "title": "Top Landing Page",
    //     "type": "top-performing",
    //     "chartType": "pie",
    //     "description": "Analyze your ad spend to maximize ROI and minimize waste.",
    //     "metricKeys": [
    //         "spend"
    //     ],
    //     "filters": [],
    //     "groupBy": {
    //         "key": "ad_landing_page",
    //         "label": "Landing Page"
    //     },
    //     "account": "674488689a710e2685c80963",
    //     "space": "68ffa9d0906349adc2ad628c",
    //     "updatedAt": "2026-06-15T18:07:09.104Z",
    //     "createdAt": "2025-10-27T17:20:25.588Z",
    //     "columns": [
    //         {
    //             "key": "spend",
    //             "name": "Spend",
    //             "color": "bg-gradient-to-r from-blue-500 to-teal-400",
    //             "fromColor": "#3B82F6",
    //             "toColor": "#2DD4BF",
    //             "currency": true,
    //             "percentages": false,
    //             "description": "Total amount of money spent on the asset.",
    //             "formula": "Sum of all expenses related to the asset.",
    //             "bestValue": "high",
    //             "isNatural": true,
    //             "displaySum": true,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "roas",
    //             "name": "ROAS",
    //             "color": "bg-gradient-to-r from-purple-500 to-pink-500",
    //             "fromColor": "#A855F7",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": false,
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "bestValue": "high",
    //             "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
    //             "formula": "Revenue / Spend",
    //             "dependsOn": [
    //                 "spend",
    //                 "purchase_value"
    //             ]
    //         },
    //         {
    //             "key": "impressions",
    //             "name": "Impressions",
    //             "color": "bg-gradient-to-r from-purple-500 to-pink-500",
    //             "fromColor": "#A855F7",
    //             "toColor": "#EC4899",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "Total number of times the ad was displayed.",
    //             "formula": "Count of ad views",
    //             "bestValue": "high",
    //             "displaySum": true,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "hook_rate",
    //             "name": "Hook Rate",
    //             "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
    //             "fromColor": "#FACC15",
    //             "toColor": "#F97316",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Percentage watching at least 3 seconds",
    //             "formula": "Hook rate (%) = (3-second video plays ÷ impressions) × 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "impressions",
    //                 "3s_video_plays"
    //             ]
    //         },
    //         {
    //             "key": "hook_to_25",
    //             "name": "Hook to 25%",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The percentage of viewers who kept watching past the hook and reached 25% of the video length.",
    //             "formula": "video_p25_watched / video_3s_plays",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "video_p25_watched",
    //                 "3s_video_plays"
    //             ]
    //         },
    //         {
    //             "key": "cpm",
    //             "name": "CPM",
    //             "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
    //             "fromColor": "#EC4899",
    //             "toColor": "#EAB308",
    //             "currency": true,
    //             "percentages": false,
    //             "description": "Cost per 1000 impressions",
    //             "formula": "(Total Spend / Total Impressions) * 1000",
    //             "bestValue": "low",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "spend",
    //                 "impressions"
    //             ]
    //         },
    //         {
    //             "key": "ctr",
    //             "name": "CTR",
    //             "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
    //             "fromColor": "#6366F1",
    //             "toColor": "#A855F7",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Click-through rate for all clicks.",
    //             "formula": "(Total Clicks / Total Impressions) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "clicks_all",
    //                 "impressions"
    //             ]
    //         },
    //         {
    //             "key": "frequency",
    //             "name": "Frequency",
    //             "color": "bg-gradient-to-r from-teal-400 to-green-500",
    //             "fromColor": "#2DD4BF",
    //             "toColor": "#22C55E",
    //             "currency": false,
    //             "percentages": false,
    //             "description": "How many times, on average, each person saw the ad during the selected date range.",
    //             "formula": "",
    //             "bestValue": "low",
    //             "displaySum": false,
    //             "displayAverage": true
    //         },
    //         {
    //             "key": "ctr_link_click",
    //             "name": "CTR (link click)",
    //             "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
    //             "fromColor": "#FACC15",
    //             "toColor": "#F97316",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "Click-through rate for link clicks.",
    //             "formula": "(Link Clicks / Impressions) * 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "link_clicks",
    //                 "impressions"
    //             ]
    //         },
    //         {
    //             "key": "click_to_atc_ratio",
    //             "name": "Click to ATC ratio",
    //             "color": "bg-gradient-to-r from-green-400 to-blue-500",
    //             "fromColor": "#4ADE80",
    //             "toColor": "#3B82F6",
    //             "currency": false,
    //             "percentages": true,
    //             "description": "The percentage of clicks that result in items being added to cart.",
    //             "formula": "Add to cart events / Total clicks × 100",
    //             "bestValue": "high",
    //             "displaySum": false,
    //             "displayAverage": true,
    //             "dependsOn": [
    //                 "atc",
    //                 "clicks_all"
    //             ],
    //             "needVerify": true
    //         }
    //     ],
    //     "customGroups": [],
    //     "icon": {
    //         "type": "icon",
    //         "value": "ph:link",
    //         "color": "text-red-500"
    //     },
    //     "sort_order": 7,
    //     "folderId": "69441bfa896921a5fb4cf4b0"
    // },
    {
        "_id": "69441d1d896921a5fb4cf4b6",
        "order": 1,
        "title": "Top Performers - Real time",
        "icon": {
            "type": "icon",
            "value": "ph:trophy",
            "color": "text-primary"
        },
        "type": "top-performing",
        "description": "See which creatives are achieving the best performance",
        "chartType": "compact",
        "segmentConfigs": {},
        "metricKeys": [
            "spend",
            "ctr",
            "impressions"
        ],
        "filters": [],
        "groupBy": {
            "key": "ad_creative",
            "label": "Creative"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-17T10:29:14.022Z",
        "createdAt": "2025-12-18T15:26:21.094Z",
        "folderId": null,
        "columns": [
            {
                "key": "spend",
                "name": "Spend",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total amount of money spent on the asset.",
                "formula": "Sum of all expenses related to the asset.",
                "bestValue": "high",
                "isNatural": true,
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "ctr",
                "name": "CTR",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": true,
                "description": "Click-through rate for all clicks.",
                "formula": "(Total Clicks / Total Impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "clicks_all",
                    "impressions"
                ]
            },
            {
                "key": "impressions",
                "name": "Impressions",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "description": "Total number of times the ad was displayed.",
                "formula": "Count of ad views",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "clicks_all",
                "name": "Clicks (all)",
                "color": "bg-gradient-to-r from-red-500 to-pink-500",
                "fromColor": "#EF4444",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "description": "Total number of clicks (all types).",
                "formula": "Sum of all clicks",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "cpm",
                "name": "CPM",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": true,
                "percentages": false,
                "description": "Cost per 1000 impressions",
                "formula": "(Total Spend / Total Impressions) * 1000",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "impressions"
                ],
                "extractors": {}
            },
            {
                "key": "cpc_all",
                "name": "CPC (all)",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": true,
                "percentages": false,
                "description": "Cost per click for all clicks.",
                "formula": "Spend / Total Clicks",
                "bestValue": "low",
                "displaySum": true,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "clicks_all"
                ]
            },
            {
                "key": "roas",
                "name": "ROAS",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "displaySum": false,
                "displayAverage": true,
                "bestValue": "high",
                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                "formula": "Revenue / Spend",
                "dependsOn": [
                    "spend",
                    "purchase_value"
                ]
            },
            {
                "key": "purchases",
                "name": "Purchases",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": false,
                "percentages": false,
                "description": "Total number of purchase events",
                "formula": "Sum of Purchase Events",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "needVerify": true,
                "extractors": {}
            },
            {
                "key": "purchase_value",
                "name": "Purchase value",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total value from purchases.",
                "formula": "Sum of Purchase Values",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "aov",
                "name": "AOV",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": true,
                "percentages": false,
                "description": "Average order value - the average amount spent per order.",
                "formula": "Total Revenue / Total Orders",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "purchase_value",
                    "purchases"
                ]
            },
            {
                "key": "hook_rate",
                "name": "Hook Rate",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": false,
                "percentages": true,
                "description": "Percentage watching at least 3 seconds",
                "formula": "Hook rate (%) = (3-second video plays ÷ impressions) × 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "impressions",
                    "3s_video_plays"
                ],
                "extractors": {}
            }
        ],
        "customGroups": [],
        "metricsDisplayMode": "cards"
    },
    {
        "_id": "69879991437843b8bcd99639",
        "order": 3,
        "title": "Creative Intelligence",
        "icon": {
            "type": "icon",
            "value": "ph:sparkle",
            "color": "text-indigo-500"
        },
        "type": "top-performing",
        "description": "See which creatives are achieving the best performance",
        "chartType": "ai-card",
        "segmentConfigs": {
            "scaled": {
                "name": "Scaled",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:chart-line-up",
                    "color": "text-gray-500",
                    "bg": "bg-gray-500"
                }
            },
            "winners": {
                "name": "Winners",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ],
                    [
                        {
                            "optionId": "metric",
                            "value": "1",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "roas",
                                "name": "ROAS",
                                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                                "fromColor": "#A855F7",
                                "toColor": "#EC4899",
                                "currency": false,
                                "percentages": false,
                                "displaySum": false,
                                "displayAverage": true,
                                "bestValue": "high",
                                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                                "formula": "Revenue / Spend",
                                "dependsOn": [
                                    "spend",
                                    "purchase_value"
                                ]
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:trophy",
                    "color": "text-secondary",
                    "bg": "bg-secondary"
                }
            }
        },
        "metricKeys": [
            "spend",
            "ctr",
            "results_data"
        ],
        "filters": [],
        "groupBy": {
            "key": "ad_creative",
            "label": "Creative"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-17T10:29:30.187Z",
        "createdAt": "2026-02-07T19:59:13.063Z",
        "columns": [
            {
                "key": "cpm",
                "name": "CPM",
                "color": "bg-gradient-to-r from-pink-500 to-yellow-500",
                "fromColor": "#EC4899",
                "toColor": "#EAB308",
                "currency": true,
                "percentages": false,
                "description": "Cost per 1000 impressions",
                "formula": "(Total Spend / Total Impressions) * 1000",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "impressions"
                ]
            },
            {
                "key": "spend",
                "name": "Spend",
                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                "fromColor": "#3B82F6",
                "toColor": "#2DD4BF",
                "currency": true,
                "percentages": false,
                "description": "Total amount of money spent on the asset.",
                "formula": "Sum of all expenses related to the asset.",
                "bestValue": "high",
                "isNatural": true,
                "displaySum": true,
                "displayAverage": true
            },
            {
                "key": "reach",
                "name": "Reach",
                "color": "bg-gradient-to-r from-teal-400 to-green-500",
                "fromColor": "#2DD4BF",
                "toColor": "#22C55E",
                "currency": false,
                "percentages": false,
                "description": "Total number of unique people who saw the ad.",
                "formula": "",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "results_data",
                "name": "Results",
                "color": "bg-gradient-to-r from-green-400 to-blue-500",
                "fromColor": "#4ADE80",
                "toColor": "#3B82F6",
                "currency": false,
                "percentages": false,
                "description": "The 'Results' defined in the ad set",
                "formula": "Sum of Results",
                "bestValue": "high",
                "displaySum": true,
                "displayAverage": true,
                "extractors": {}
            },
            {
                "key": "cost_per_results_data",
                "name": "Cost per result",
                "color": "bg-gradient-to-r from-yellow-400 to-orange-500",
                "fromColor": "#FACC15",
                "toColor": "#F97316",
                "currency": true,
                "percentages": false,
                "description": "Cost per result",
                "formula": "Total Spend / Total Results",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend"
                ],
                "extractors": {}
            },
            {
                "key": "ctr",
                "name": "CTR",
                "color": "bg-gradient-to-r from-indigo-500 to-purple-500",
                "fromColor": "#6366F1",
                "toColor": "#A855F7",
                "currency": false,
                "percentages": true,
                "description": "Click-through rate for all clicks.",
                "formula": "(Total Clicks / Total Impressions) * 100",
                "bestValue": "high",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "clicks_all",
                    "impressions"
                ]
            },
            {
                "key": "roas",
                "name": "ROAS",
                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                "fromColor": "#A855F7",
                "toColor": "#EC4899",
                "currency": false,
                "percentages": false,
                "displaySum": false,
                "displayAverage": true,
                "bestValue": "high",
                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                "formula": "Revenue / Spend",
                "dependsOn": [
                    "spend",
                    "purchase_value"
                ]
            },
            {
                "key": "cost_per_purchase",
                "name": "Cost per purchase",
                "color": "bg-gradient-to-r from-green-400 to-blue-500",
                "fromColor": "#4ADE80",
                "toColor": "#3B82F6",
                "currency": true,
                "percentages": false,
                "description": "Cost per purchase - the cost to acquire a customer or conversion.",
                "formula": "Total Spend / Total Purchases",
                "bestValue": "low",
                "displaySum": false,
                "displayAverage": true,
                "dependsOn": [
                    "spend",
                    "purchases"
                ]
            }
        ],
        "customGroups": [],
        "metricsDisplayMode": "cards"
    },
    {
        "_id": "699702e5a5dcf01facd501c2",
        "order": 2,
        "title": "Launch Report Weekly - Ron",
        "icon": {
            "type": "icon",
            "value": "ph:rocket",
            "color": "text-primary"
        },
        "type": "launch",
        "description": "Track and analyze ads launched since a specific date with customizable segments",
        "chartType": "card",
        "segmentConfigs": {
            "scaled": {
                "name": "Scaled",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:chart-line-up",
                    "color": "text-gray-500",
                    "bg": "bg-gray-500"
                }
            },
            "winners": {
                "name": "Winners",
                "groupFilters": [
                    [
                        {
                            "optionId": "metric",
                            "value": "500",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "spend",
                                "name": "Spend",
                                "color": "bg-gradient-to-r from-blue-500 to-teal-400",
                                "fromColor": "#3B82F6",
                                "toColor": "#2DD4BF",
                                "currency": true,
                                "percentages": false,
                                "description": "Total amount of money spent on the asset.",
                                "formula": "Sum of all expenses related to the asset.",
                                "bestValue": "high",
                                "isNatural": true,
                                "displaySum": true,
                                "displayAverage": true
                            }
                        }
                    ],
                    [
                        {
                            "optionId": "metric",
                            "value": "1",
                            "operatorValue": "greater",
                            "label": "Metric",
                            "chosenMetric": {
                                "key": "roas",
                                "name": "ROAS",
                                "color": "bg-gradient-to-r from-purple-500 to-pink-500",
                                "fromColor": "#A855F7",
                                "toColor": "#EC4899",
                                "currency": false,
                                "percentages": false,
                                "displaySum": false,
                                "displayAverage": true,
                                "bestValue": "high",
                                "description": "Return on ad spend - a ratio of revenue generated for every dollar spent.",
                                "formula": "Revenue / Spend",
                                "dependsOn": [
                                    "spend",
                                    "purchase_value"
                                ]
                            }
                        }
                    ]
                ],
                "icon": {
                    "type": "icon",
                    "value": "ph:trophy",
                    "color": "text-secondary",
                    "bg": "bg-secondary"
                }
            }
        },
        "metricKeys": [
            "spend",
            "roas"
        ],
        "filters": [],
        "groupBy": {
            "key": "ad_name",
            "label": "Ad Name"
        },
        "account": "674488689a710e2685c80963",
        "space": "68ffa9d0906349adc2ad628c",
        "updatedAt": "2026-06-15T18:07:09.112Z",
        "createdAt": "2026-02-19T12:32:37.051Z"
    }
]


export const DEFAULT_DASHBOARD = [
    {
        "order": 0,
        "title": "Overview",
        "description": "Account performance at a glance — scorecard, trend, segments, and campaigns.",
        "icon": {
            "value": "ph:chart-pie-slice",
            "color": "text-primary"
        },
        "scope": {
            "dateRange": {
                "mode": "preset",
                "preset": "last_30d"
            },
            "compareDates": {
                "enabled": true,
                "mode": "absolute",
                "from": "2026-04-17T10:26:01.857Z",
                "to": "2026-05-17T10:26:01.857Z"
            },
            "filters": [],
            "adAccountIds": [
            ],
            "integrationIds": [
            ]
        },
        "widgets": [
            {
                "type": "account-scorecard",
                "title": "Scorecard",
                "layout": {
                    "x": 0,
                    "y": 0,
                    "w": 12,
                    "h": 3
                },
                "config": {
                    "metricKeys": [
                        "spend",
                        "ctr",
                        "impressions",
                        "clicks_all"
                    ],
                    "showCompare": true
                },
                "id": "w_mtgurj1z",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "chart-line",
                "title": "Performance trend",
                "layout": {
                    "x": 0,
                    "y": 5,
                    "w": 12,
                    "h": 8
                },
                "config": {
                    "groupBy": {
                        "key": "ad_creative",
                        "label": "Creative"
                    },
                    "metricKeys": [
                        "ctr",
                        "cpm"
                    ],
                    "daysSplit": 1
                },
                "id": "w_6hh6mv6z",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "account-breakdown",
                "title": "Demographics",
                "layout": {
                    "x": 0,
                    "y": 13,
                    "w": 6,
                    "h": 9
                },
                "config": {
                    "dimension": "demographic",
                    "metricKeys": [
                        "spend"
                    ],
                    "topN": 10,
                    "sortBy": "spend"
                },
                "id": "w_x597c9fv",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "account-breakdown",
                "title": "Top countries",
                "layout": {
                    "x": 6,
                    "y": 13,
                    "w": 6,
                    "h": 9
                },
                "config": {
                    "dimension": "country",
                    "metricKeys": [
                        "roas"
                    ],
                    "topN": 10,
                    "sortBy": "roas"
                },
                "id": "w_9as99mk6",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "account-campaigns",
                "title": "Campaigns",
                "layout": {
                    "x": 0,
                    "y": 22,
                    "w": 12,
                    "h": 10
                },
                "config": {
                    "metricKeys": [
                        "spend",
                        "roas",
                        "purchases",
                        "ctr"
                    ],
                    "topN": 20,
                    "sortBy": "spend",
                    "showAccountTotal": true
                },
                "id": "w_zgmrywsc",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "account-breakdown",
                "title": "Top countries",
                "layout": {
                    "x": 0,
                    "y": 22,
                    "w": 6,
                    "h": 9
                },
                "config": {
                    "dimension": "platform",
                    "metricKeys": [
                        "spend"
                    ],
                    "topN": 10,
                    "sortBy": "roas"
                },
                "id": "w_egf5zkrn",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            },
            {
                "type": "account-breakdown",
                "title": "Top countries",
                "layout": {
                    "x": 6,
                    "y": 22,
                    "w": 6,
                    "h": 9
                },
                "config": {
                    "dimension": "placement",
                    "metricKeys": [
                        "spend"
                    ],
                    "topN": 10,
                    "sortBy": "roas"
                },
                "id": "w_t2eop242",
                "override": {
                    "adAccountIds": [
                        "act_10271952"
                    ],
                    "integrationIds": [
                        "6931b77126041d5a0d041216"
                    ]
                }
            }
        ]
    },
    {
        "order": 0,
        "title": "Video Highlights",
        "description": "Top-performing video ads with watch-retention at a glance.",
        "icon": {
            "value": "mdi:star-outline",
            "color": "text-primary"
        },
        "scope": {
            "dateRange": {
                "mode": "preset",
                "preset": "last_30d"
            },
            "compareDates": null,
            "filters": [],
            "adAccountIds": [
            ],
            "integrationIds": [
            ]
        },
        "widgets": [
            {
                "type": "account-scorecard",
                "title": "Video metrics",
                "layout": {
                    "x": 0,
                    "y": 0,
                    "w": 12,
                    "h": 3
                },
                "config": {
                    "metricKeys": [
                        "video_plays",
                        "thruplay",
                        "video_avg_time_watched",
                        "hook_rate"
                    ],
                    "showCompare": true
                },
                "id": "w_n58k2tbr",
                "override": {
                    "adAccountIds": [
                    ],
                    "integrationIds": [
                    ]
                }
            },
            {
                "type": "creative-highlights",
                "title": "Top video ads",
                "layout": {
                    "x": 0,
                    "y": 3,
                    "w": 12,
                    "h": 7
                },
                "config": {
                    "groupBy": {
                        "key": "ad_creative",
                        "label": "Creative"
                    },
                    "metricKeys": [
                        "hook_rate",
                        "hold_rate",
                        "thruplay"
                    ]
                },
                "id": "w_qmfl6icx",
                "override": {
                    "adAccountIds": [
                    ],
                    "integrationIds": [
                    ]
                }
            },
            {
                "type": "chart-comparison",
                "title": "Video metrics by creative",
                "layout": {
                    "x": 0,
                    "y": 10,
                    "w": 12,
                    "h": 10
                },
                "config": {
                    "groupBy": {
                        "key": "ad_creative",
                        "label": "Creative"
                    },
                    "metricKeys": [
                        "spend",
                        "hook_rate",
                        "hold_rate",
                        "thruplay",
                        "video_avg_time_watched"
                    ],
                    "displayCount": 6
                },
                "id": "w_jtjxc535",
                "override": {
                    "adAccountIds": [
                    ],
                    "integrationIds": [
                    ]
                }
            },
            {
                "type": "chart-bar",
                "title": "Impressions & hook rate",
                "layout": {
                    "x": 0,
                    "y": 20,
                    "w": 12,
                    "h": 9
                },
                "config": {
                    "groupBy": {
                        "key": "ad_creative",
                        "label": "Creative"
                    },
                    "metricKeys": [
                        "impressions",
                        "hook_rate"
                    ]
                },
                "id": "w_4ssb139f",
                "override": {
                    "adAccountIds": [
                    ],
                    "integrationIds": [
                    ]
                }
            }
        ]
    }
]